import { Button, Modal, Typography } from 'antd';
import React, { useState } from 'react'
import portalAPI from "../../api/api";
import { YODLEE_TOKEN_URL } from "../../api/URLs";
import { useSelector } from "react-redux";
import LinkIcon from '../../assets/icons/link.svg';
import "./fast-link-bank.css";

const FastLinkBank = (props) => {
    const { setSites, setAccessToken } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onModalClose = () => {
        setIsModalOpen(false);
    }

    const handleLink = async () => {
        if (!window.fastlink) {
            alert("FastLink SDK not loaded yet.");
            return;
        }
        setIsModalOpen(true);
        try {
            const tokenReq = await portalAPI.get(YODLEE_TOKEN_URL);
            const token = tokenReq.data.token.accessToken;
            const fastLinkUrl = tokenReq.data.fastLink.url;
            const configName = tokenReq.data.fastLink.configName;
            setAccessToken(token);
            try {
                window.fastlink.open({
                    forceIframe: true,
                    fastLinkURL: fastLinkUrl,
                    accessToken: `Bearer ${token}`,
                    params: {
                        configName // ✅ use this
                    },
                    onSuccess: function (data) {
                        // will be called on success. For list of possible message, refer to onSuccess(data) Method.
                        console.log('success', data);
                    },
                    onError: function (data) {
                        // will be called on error. For list of possible message, refer to onError(data) Method.
                        console.log(data);
                    },
                    onClose: function (data) {
                        // will be called called to close FastLink. For list of possible message, refer to onClose(data) Method.
                        setIsModalOpen(false);
                        console.log(data);
                        let newSite = data?.sites.filter((item) => item.status === 'SUCCESS')
                        setSites(newSite);
                    },
                    onEvent: function (data) {
                        // will be called on intermittent status update.
                        console.log('onEvent', data);
                    }
                }, 'container-fastlink');
            } catch (err) {
                console.error("Error launching FastLink:", err);
            }
        } catch (err) {
            console.error("Error launching FastLink:", err);
        }
    };

    return (
        <div>
            <Modal
                // title="Connect Bank Account"
                open={isModalOpen}
                onCancel={onModalClose}
                footer={null}
                width={800}
                header={null}
                className='fast-link-modal'
            >
                <div id="container-fastlink"></div>
            </Modal>
            <Button
                className='link-bank-btn'
                size='large'
                onClick={handleLink}
            >
                Link Bank Account with Envestnet | Yodlee <img src={LinkIcon} alt='Link Icon' />
            </Button>
        </div>
    )
}

export default FastLinkBank